import React, { Component } from 'react'

class Progress extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        return (
            <div className="UploadProgressBar">
                <div
                    className="UploadProgress"
                    style={{ width: this.props.progress + '%' }}
                />
            </div>
        )
    }
}

export default Progress